(function(){
  document.addEventListener('DOMContentLoaded', function(){
    fetch('https://www.mf-orii.co.jp/news/wp-json/wp/v2/posts?categories=2')
      .then((response) => response.json())
      .then((data) => {
        const news_container = document.getElementById('wp_shop_news');
        let table_obj = document.createElement('table');
        news_container.appendChild(table_obj);
        data.forEach(function(item){
          let row_dom = document.createElement('tr');
          table_obj.appendChild(row_dom);
          let date_dom = document.createElement('td');
          let date_obj = new Date(item.date);
          date_dom.classList.add('date');
          date_dom.innerHTML = date_obj.getFullYear() + '.' + (date_obj.getMonth() + 1).toString().padStart(2, '0') + '.' + date_obj.getDate().toString().padStart(2, '0');
          row_dom.appendChild(date_dom);
          let title_dom = document.createElement('td');
          let link_dom = document.createElement('a');
          link_dom.href = item.link;
          link_dom.innerHTML = item.title.rendered;
          title_dom.classList.add('title');
          title_dom.appendChild(link_dom);
          row_dom.appendChild(title_dom);
        })
      })
  })
})()